// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedCpfWage: null
}

const cpfWages = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_CPF_WAGES_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_CPF_WAGES':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_CPF_WAGES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_CPF_WAGE':
      return { ...state, selectedCpfWage: action.selectedCpfWage }
    case 'ADD_CPF_WAGE':
      return { ...state }
    case 'DELETE_CPF_WAGE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default cpfWages
